
const InputChange = (setState,value) => {
       setState(value)
}

export default InputChange